import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: 'نام و نام خانوادگی', value: 'fullName', align: 'center' },
        { text: 'شماره پرسنلی', value: 'personalNumber', align: 'center' },
        { text: 'تاریخ ورود', value: 'loginDate', align: 'center' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'center' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      roleId: null,
      userFullName: '',
      userId: null,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let fullName = '';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].userFirstName) {
          fullName += data[i].userFirstName + ' ';
        } else {
          fullName += '-';
        }
        if (data[i].userLastName) {
          fullName += data[i].userLastName;
        } else {
          fullName += '-';
        }
        this.tableItems.push({
          fullName: fullName,
          loginDate: loginDate,
          logoutDate: logoutDate,
          personalNumber: data[i].personnelNumber ? data[i].personnelNumber : '-',
          duration: this.msToTime(duration),
        });
      }
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.userId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.userId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCUsersLoginLogoutReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.userId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.userId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      if (this.roleId == 3) {
        this.$router.push({ name: 'qcUser115Dashboard', params: { id: id } });
      } else if (this.roleId == 2) {
        this.$router.push({ name: 'qcUser800Dashboard', params: { id: id } });
      } else if (this.roleId == 5) {
        this.$router.push({
          name: 'qcUserTechnicianDashboard',
          params: { id: id },
        });
      } else if (this.roleId == 8) {
        this.$router.push({
          name: 'qcUserDoctorDashboard',
          params: { id: id },
        });
      } else if (this.roleId == 6) {
        this.$router.push({
          name: 'qcUserAdmissionDashboard',
          params: { id: id },
        });
      }
    },
  },
};
